import Header from "component/Common/Header/Header";
import NotificationBar from "component/Common/NotificationBar/NotificationBar";
import SideBar from "component/Common/SideBar/SideBar";
import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

export function DashboardLayout(props) {
  const { isOpen } = useSelector((state) => state.notification);
  const notificationRef = useRef(null);

  useEffect(() => {
    if (notificationRef.current) {
      notificationRef.current.style.width = isOpen ? "350px" : "0px"
    }
  }, [isOpen]);

  return (
    <div className="container-fluid px-0">
      <div className="hideOnPrint">
        <Header />
      </div>
      <div className="dashboardLayoutBox">
        <div className="sidebarBox hideOnPrint">
          <SideBar />
        </div>
        <div className="mainContentBox">
          <div className="container">{props.children}</div>
        </div>
        <div className="notificationBar" ref={notificationRef}>
          <NotificationBar />
        </div>
      </div>
    </div>
  );
}
